import { render, staticRenderFns } from "./ImprovementTipsCard.vue?vue&type=template&id=35c591b6&"
import script from "./ImprovementTipsCard.vue?vue&type=script&lang=js&"
export * from "./ImprovementTipsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports